module.exports = __webpack_public_path__ + "img/PDF_file_icon2.ca0373da.png";